// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-link-container {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: var(--secondary-color);
	width: 100%;
	height: 50px;
	margin-bottom: 15px;
	font-size: 17px;
	text-decoration: none;
	transition: color 0.2s;
	border-radius: 5px;
	border: none;
}

.card-link-container:hover {
	scale: 1.03;
	background-color: var(--secondary-hover);
	transition: all 0.2s ease;
}

.card-link {
	background-color: transparent;
	border: none;
	color: var(--primary-color);
	font-size: 19px;
	width: 100%;
	height: 100%;
	font-weight: 600;
}

.card-link:hover {
	color: black;
}

@media (max-width: 480px) {
	.card-link {
		font-size: 17px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/ManagementCard/ManagementCardContent.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,wCAAwC;CACxC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,wCAAwC;CACxC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,2BAA2B;CAC3B,eAAe;CACf,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".card-link-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: var(--secondary-color);\n\twidth: 100%;\n\theight: 50px;\n\tmargin-bottom: 15px;\n\tfont-size: 17px;\n\ttext-decoration: none;\n\ttransition: color 0.2s;\n\tborder-radius: 5px;\n\tborder: none;\n}\n\n.card-link-container:hover {\n\tscale: 1.03;\n\tbackground-color: var(--secondary-hover);\n\ttransition: all 0.2s ease;\n}\n\n.card-link {\n\tbackground-color: transparent;\n\tborder: none;\n\tcolor: var(--primary-color);\n\tfont-size: 19px;\n\twidth: 100%;\n\theight: 100%;\n\tfont-weight: 600;\n}\n\n.card-link:hover {\n\tcolor: black;\n}\n\n@media (max-width: 480px) {\n\t.card-link {\n\t\tfont-size: 17px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
